// app/providers.tsx
'use client';

import React from 'react';

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Bounce, ToastContainer } from 'react-toastify';
import { Provider } from "react-redux";
import { store } from "./lib/store/store";
import { ChatProvider } from "./lib/context/ChatContext";
import 'react-toastify/dist/ReactToastify.css';
import { UserSessionProvider } from "./lib/context/UserSessionContext";
import { TagEditorProvider } from "./lib/context/TagEditorContext";
import { NewChatProvider } from "./lib/context/NewChatContext";
import { MultiProductsLifeStyleImageGenProvider } from './lib/context/MultiProductsLifeStyleImageGenContext';

const queryClient = new QueryClient();

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <UserSessionProvider>
          <ChatProvider>
            <NewChatProvider>
              <MultiProductsLifeStyleImageGenProvider>
                <TagEditorProvider>
                  <>
                    {children}
                    <ToastContainer
                      position="bottom-right"
                      autoClose={5000}
                      hideProgressBar
                      closeOnClick={false}
                      pauseOnHover
                      draggable
                      closeButton={false}
                      transition={Bounce}
                      limit={3}
                      style={{ ["--toastify-z-index" as string]: "9000" }}
                      toastClassName={() =>
                        `bg-[#FFE3D3] text-[#333]
                        rounded-lg shadow-md
                        px-2 py-2 min-h-[60px]
                        font-sans`
                      }
                      className="p-0 m-0"
                    />
                    {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                  </>
                </TagEditorProvider>
              </MultiProductsLifeStyleImageGenProvider>
            </NewChatProvider>
          </ChatProvider>
        </UserSessionProvider>
      </QueryClientProvider>
    </Provider>
  );
}
